import createReducer from "./createReducer";
import { CONTENT_FEED_ACTIONS } from "./actions/ContentFeedActions";
import { mergeItem } from "utils/common";

const initialState = {
	items: [],
	isLoading: false,
	hasErrorLoading: false,
};

const ASSIGNED_CREATIVES_ACTIONS = {
	FETCH_ASSIGNED_CREATIVES_AJAX: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_AJAX,
	FETCH_ASSIGNED_CREATIVES_SUCCESS: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_SUCCESS,
	FETCH_ASSIGNED_CREATIVES_ERROR: CONTENT_FEED_ACTIONS.FETCH_ASSIGNED_CREATIVES_ERROR,
	RESET_ASSIGNED_CREATIVES: "RESET_ASSIGNED_CREATIVES",
};

export const handlers = {
	[ASSIGNED_CREATIVES_ACTIONS.FETCH_ASSIGNED_CREATIVES_AJAX]: fetchAssignedCreatives,
	[ASSIGNED_CREATIVES_ACTIONS.FETCH_ASSIGNED_CREATIVES_SUCCESS]: fetchAssignedCreativesSuccess,
	[ASSIGNED_CREATIVES_ACTIONS.FETCH_ASSIGNED_CREATIVES_ERROR]: fetchAssignedCreativesError,
	[ASSIGNED_CREATIVES_ACTIONS.RESET_ASSIGNED_CREATIVES]: resetAssignedCreatives,
	[CONTENT_FEED_ACTIONS.TOGGLE_CREATIVE_AUTO_UPDATES_SUCCESS]: updateCreativeAutoUpdates,
};

function fetchAssignedCreatives(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

const API_STATUS_DONE = "done";
const NORMALIZED_STATUS_SUCCESS = "success";

function normalizeLastUpdateStatus(lastUpdateStatus) {
	if (!lastUpdateStatus) {
		return undefined;
	}
	return lastUpdateStatus === API_STATUS_DONE ? NORMALIZED_STATUS_SUCCESS : lastUpdateStatus;
}

function fetchAssignedCreativesSuccess(state, action) {
	const { data } = action.payload;
	const rawItems = data.data || [];
	const mappedItems = rawItems.map(item => ({
		...item,
		lastUpdateStatus: normalizeLastUpdateStatus(item.lastUpdateStatus),
	}));

	return {
		...state,
		items: mappedItems,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function fetchAssignedCreativesError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

function resetAssignedCreatives(state, action) {
	return {
		...initialState,
	};
}

function updateCreativeAutoUpdates(state, action) {
	const { idCreative, enableUpdate } = action.payload.original;
	const currentItem = state.items.find(item => item.idCreative === idCreative);

	if (!currentItem) {
		return state;
	}

	const updatedItem = {
		...currentItem,
		enableUpdate,
	};

	return {
		...state,
		items: mergeItem(state.items, updatedItem),
	};
}

export function clearAssignedCreatives() {
	return {
		type: ASSIGNED_CREATIVES_ACTIONS.RESET_ASSIGNED_CREATIVES,
	};
}

let reducerConfig = {
	typeRoot: "ASSIGNED_CREATIVES",
	actionTypes: ASSIGNED_CREATIVES_ACTIONS,
	actionCreators: {
		clearAssignedCreatives,
	},
	initialState,
	handlers,
};

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const AssignedCreatives = reducerConfig.actionCreators;

